import { useMemo } from 'react';

export const useGetEPCAdminMenuItems = ({
  epcPayoutsAccess,
  epcDashboardAccess,
  feocDcCalculator,
  enableLeadManagement = false,
  onPointClaimFormAccess = false,
  hasItcEligibilityProgramType,
}: {
  epcPayoutsAccess: boolean;
  epcDashboardAccess: boolean;
  feocDcCalculator: boolean;
  enableLeadManagement?: boolean;
  onPointClaimFormAccess?: boolean;
  hasItcEligibilityProgramType: boolean;
}) => {
  return useMemo(
    () => [
      ...(epcPayoutsAccess ? [{ name: 'Payouts', path: '/admin/payouts/queued' }] : []),
      ...(epcDashboardAccess ? [{ name: 'Dashboard', path: '/admin/dashboard' }] : []),
      ...(feocDcCalculator && hasItcEligibilityProgramType
        ? [{ name: 'ITC Eligibility Calculator', path: '/admin/itc-eligibility-calculator' }]
        : []),
      ...(enableLeadManagement ? [{ name: 'Lead Management', path: '/admin/lead-management' }] : []),
      ...(onPointClaimFormAccess
        ? [
            {
              name: 'OnPoint Claim Form',
              path: 'https://onpoint-warranty-palmetto-hvac.kustomer.help/contact/palmetto-claim-form-HkvBAJukl',
              external: true,
            },
          ]
        : []),
    ],
    [
      epcPayoutsAccess,
      epcDashboardAccess,
      feocDcCalculator,
      enableLeadManagement,
      onPointClaimFormAccess,
      hasItcEligibilityProgramType,
    ],
  );
};
